var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useColumnSelect } from '../../../hooks';
import ChipWithMenu from './ChipWithMenu';
import theme from '../../theme';
var DimensionChips = function (_a) {
    var destination = _a.destination, dimensionKey = _a.dimensionKey;
    var classes = useStyles();
    var onDimensionChange = useColumnSelect(dimensionKey).onDimensionChange;
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Box, { className: classes.dimensionLabel }, dimensionKey),
        React.createElement(Box, { className: classes.selectGroup },
            React.createElement("div", { className: classes.selectLabel + " " + classes.groupItem }, "Columns: "),
            React.createElement(Autocomplete, { multiple: true, classes: { root: classes.Autocomplete, input: classes.groupItem }, size: "small", options: destination.columns, getOptionLabel: function (option) { return option.key; }, onChange: onDimensionChange, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { variant: "standard" })); }, renderTags: function (tagValue, getTagProps) {
                    return tagValue.map(function (option, index) {
                        return dimensionKey === 'measures' ? (React.createElement(ChipWithMenu, __assign({}, getTagProps({ index: index }), { label: option.key, destination: destination }))) : (React.createElement(Chip, __assign({ label: option.key }, getTagProps({ index: index }))));
                    });
                } }))));
};
var useStyles = makeStyles({
    root: {
        flex: 1,
        minWidth: 160,
        textAlign: 'center',
    },
    dimensionLabel: {
        width: '100%',
        padding: '6px 0',
        background: '#dde6ed',
        '&.Mui-focused': {
            color: '#293845',
        },
    },
    Autocomplete: {
        display: 'flex',
        flexGrow: 1,
        '& * .MuiInputLabel-root': {
            left: '10px',
            color: theme.palette.text.primary,
        },
        '& * .MuiInputBase-input': {
            padding: '5px 0px 7px!important',
            flexBasis: '100%',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(41, 56, 69, 0.1)',
        },
    },
    selectGroup: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        boxSizing: 'border-box',
        marginTop: 12,
        marginBottom: 12,
    },
    groupItem: {
        display: 'flex',
        margin: '6px 0',
    },
    selectLabel: {
        fontSize: 16,
        marginLeft: 11,
        marginRight: 6,
    },
    inputLabel: {
        top: 'inherit',
        left: 10,
    },
    optionFormula: {
        margin: 'inherit',
    },
    subSelect: {
        fontSize: '0.86em',
    },
});
export default DimensionChips;
